import { useLingui } from "@lingui/react"
import { sentimentLabelFor } from "../../../../lib/sentiment"
import type { IProps } from "./interfaces"

export function SentimentLabel({ overall }: IProps): React.JSX.Element {
  const { i18n } = useLingui()
  // Shared label set (lib/sentiment) — same vocabulary MeetingCard uses.
  // Unknown classifications fall through to the raw analyser string.
  return <>{sentimentLabelFor(i18n, overall) ?? overall}</>
}
